export default __webpack_public_path__ + "static/media/poster1.782d5533.jpg";